import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { SubmitButtonVariant } from '../../../../../utils/getSubmitButtonVariant'
import { shouldUseDKReportContent } from '../../../../../utils/isSupportedCountryId'
import { VatDeclarationsDropdownActionType } from '../enums/vatDeclarationsDropdownActionType'

interface GetVatDeclarationsItemsProps {
  country?: string
  isPeriodPaid?: boolean
  isPeriodSettled?: boolean
  submitButtonVariant?: SubmitButtonVariant | null
  t: TFunction
}

export const getVatDeclarationsItems = ({
  country,
  isPeriodPaid,
  isPeriodSettled,
  submitButtonVariant,
  t,
}: GetVatDeclarationsItemsProps): NavItem<VatDeclarationsDropdownActionType>[] => {
  const items: NavItem<VatDeclarationsDropdownActionType>[] = [
    {
      children: t('vat_declarations.actions.export'),
      id: VatDeclarationsDropdownActionType.Export,
      value: VatDeclarationsDropdownActionType.Export,
    },
  ]

  if (!isPeriodSettled && (country === 'NL' || shouldUseDKReportContent(country))) {
    items.push({
      children: t('vat_declarations.actions.adjust_vat_period'),
      id: VatDeclarationsDropdownActionType.ChangePeriod,
      value: VatDeclarationsDropdownActionType.ChangePeriod,
    })

    /* Only show manual settlement button when not in draft state + external submission integration is available */
    /* If external submission integration is available, main button is Submit via integration */
    /* If external submission is not available, main button is Submit manually */
    if (submitButtonVariant === SubmitButtonVariant.Integration) {
      items.push({
        children: t('vat_declarations.submit_manually'),
        id: VatDeclarationsDropdownActionType.SubmitManually,
        value: VatDeclarationsDropdownActionType.SubmitManually,
      })
    }
  }

  if (isPeriodSettled && !isPeriodPaid) {
    items.push({
      children: t('vat_declarations.actions.void_settlement'),
      id: VatDeclarationsDropdownActionType.VoidSettlement,
      value: VatDeclarationsDropdownActionType.VoidSettlement,
    })
  }

  if (isPeriodPaid) {
    items.push({
      children: t('vat_declarations.actions.void_payment'),
      id: VatDeclarationsDropdownActionType.VoidPayment,
      value: VatDeclarationsDropdownActionType.VoidPayment,
    })
  }

  return items
}
